export const supportedBrands = [
	'amex',
	'diners',
	'visa',
	'discover',
	'mc',
	'jcb',
	'maestro_usa',
];

export const baseStyles = {
	base: {
		color: '#666666',
		fontWeight: '300',
		fontSize: '16px',
		fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
	},
	placeholder: {
		color: '#8c8c8c',
		fontSize: '16px',
	},
};
